import {postWithAuth} from '@/api'
import {
    MakeTransferRequest,
    MakeTransferResponse
} from '@/stores/business-account/make-transfer/models'

export const makeTransfer = (data: Partial<MakeTransferRequest>) =>
    postWithAuth<MakeTransferResponse>('/oppapi/v2/card-issuing/transfers', data)
